<template>
  <div class="manager_dashboard">
    <UserMenu></UserMenu>
    <div class="wrapper">
      <EnterprieSidebarMenu :show_menu="true" :show_back_button="false" back_link="managerReports"></EnterprieSidebarMenu>

      <div class="content-wrapper padding-left-165">
        <div class="container-wrapper center">
          <div class="margin-bottom-10"></div>

					<h1 class="reports-title">Reports</h1>

					<div class="reports-grid">
						<div
							v-for="report in reports"
							:key="report.id"
							class="report-card"
							@mouseenter="hoveredId = report.id"
							@mouseleave="hoveredId = null"
							:style="cardStyle(report)"
						>
							<div class="report-icon" :style="{ color: report.iconColor, backgroundColor: `color-mix(in oklab, ${report.iconBg} 10%, transparent)` }" v-html="report.iconSvg" />

							<h2 class="report-name">{{ report.name }}</h2>
							<p class="report-description">{{ report.description }}</p>

							<button class="open-report-btn" @click="openReport(report)">
								Open Report
							</button>
						</div>
					</div>
				
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import EnterprieSidebarMenu from '@/components/shared/enterpriseadmin_sidebar_menu.vue';
import UserMenu from '@/components/shared/user_menu.vue';
import router from '../../router/index.js';

export default {
  name: "ReportsDashboard",
  components: {
    EnterprieSidebarMenu,
		UserMenu
  },

  data() {
    return {
			hoveredId: null,
      reports: [
        {
          id: 'progress',
          name: 'Progress Report',
          description: 'Detailed breakdown of course completion and pathway progress across mentees.',
					cardBorder: '#bfdbfe90',
          iconColor: '#2b7fff',
          iconBg: '#2b7fff',
          iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-no-axes-column-increasing w-6 h-6 text-blue-500" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/pages/Reports.tsx:108:16" data-component-name="report.icon"><path d="M5 21v-6"></path><path d="M12 21V9"></path><path d="M19 21V3"></path></svg>`,
					link: '/enterpriseadmin/pathway-progress-report',
        },
        {
          id: 'tasks-reps',
          name: 'Tasks & Reps Report',
          description: 'Track submission status and review pending tasks across all mentoring pairs.',
					cardBorder: '#fde68a90',
          iconColor: '#fe9a00',
          iconBg: '#fe9a00',
          iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-check-big w-6 h-6 text-amber-500" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/pages/Reports.tsx:108:16" data-component-name="report.icon"><path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344"></path><path d="m9 11 3 3L22 4"></path></svg>`,
					link: '/enterprise-admin/rep-audit-trail/All',
        },
        {
          id: 'competency',
          name: 'Competency Report',
          description: 'View competencies earned and certification progress (OEM/ASE) by pathway.',
					cardBorder: '#6ee7b790',
          iconColor: '#00bc7d',
          iconBg: '#00bc7d',
          iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-award w-6 h-6 text-emerald-500" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/pages/Reports.tsx:108:16" data-component-name="report.icon"><path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path><circle cx="12" cy="8" r="6"></circle></svg>`,
					link: '/enterprise-admin/competency-report-overview/All',
        },
        {
          id: 'Mentee-comparison',
          name: 'Mentee Comparison',
          description: 'Compare mentee progress across locations. Filter by pathway, location, or group to identify gaps.',
					cardBorder: '#00ACEE50',
          iconColor: '#00ACEE',
          iconBg: '#00ACEE',
          iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-git-compare-arrows w-6 h-6 text-[#00ACEE]" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/pages/Reports.tsx:108:16" data-component-name="report.icon"><circle cx="5" cy="6" r="3"></circle><path d="M12 6h5a2 2 0 0 1 2 2v7"></path><path d="m15 9-3-3 3-3"></path><circle cx="19" cy="18" r="3"></circle><path d="M12 18H7a2 2 0 0 1-2-2V9"></path><path d="m9 15 3 3-3 3"></path></svg>`,
					link: '/enterpriseadmin/mentee-comparison-report',
        },
        {
          id: 'usage-activity',
          name: 'Usage & Activity Report',
          description: 'System activity overview, top performers, and mentor engagement metrics.',
					cardBorder: '#c4b5fd90',
          iconColor: '#ad46ff',
          iconBg: '#ad46ff',
          iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-activity w-6 h-6 text-purple-500" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/pages/Reports.tsx:108:16" data-component-name="report.icon"><path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"></path></svg>`,
					link: '/enterprise-admin/usage_report',
        },
			],
    };
  },
  methods: {
    isHovered(report) {
      return this.hoveredId === report.id;
    },
    cardStyle(report) {
      if (this.isHovered(report)) {
        return {
          borderColor: '#cbd5e1',
          cursor: 'pointer',
        };
      }
      return {
        borderColor: report.cardBorder,
      };
    },
    openReport(report) {
      router.push(report.link);
    },
  },

};
</script>

<style scoped>
.reports-page {
  padding: 24px 32px;
  background-color: #f8fafc;
  min-height: 100%;
}

.reports-title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 24px 0;
}

.reports-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.report-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: background-color 0.2s ease, border-color 0.1s ease, box-shadow 0.1s ease;
	opacity: 0.85;
	box-shadow:
    0 0 0 0.5px var(--card-border-color, #e2e8f0),
    0 4px 16px -2px rgba(0, 0, 0, 0.08),
    0 1px 4px rgba(0, 0, 0, 0.04);
}

.report-card:hover {
  box-shadow:
    0 0 0 1.5px #cbd5e1,
    0 6px 20px -2px rgba(0, 0, 0, 0.12),
    0 2px 6px rgba(0, 0, 0, 0.06);

	cursor: default !important;
}

.report-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  flex-shrink: 0;
}

.report-name {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.3;
}

.report-description {
  font-size: 13.5px;
  color: #64748b;
  line-height: 1.55;
  margin: 0;
  flex: 1;
}

.open-report-btn {
  margin-top: 12px;
  width: 100%;
  padding: 9px 16px;
  background: transparent;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  color: #334155;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.open-report-btn:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
  color: #1e293b;
}

@media (max-width: 900px) {
  .reports-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 580px) {
  .reports-grid {
    grid-template-columns: 1fr;
  }

  .reports-page {
    padding: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterprise_reports_new.vue